import React from 'react';

const Logo = ({ size = 'default', className = '', variant = 'default' }) => {
  const dimensions = {
    small: { height: 32 },
    default: { height: 50 },
    large: { height: 65 }
  };

  const { height } = dimensions[size] || dimensions.default;

  // For dark backgrounds (footer), apply filter to make dark elements white
  const filterStyle = variant === 'light' ? {
    filter: 'brightness(0) invert(1)'
  } : {};

  return (
    <img
      src="/logo.gif"
      alt="Global Trademark Pro Logo"
      style={{ 
        height: `${height}px`, 
        width: 'auto',
        maxWidth: '100%',
        ...filterStyle
      }}
      className={`${className}`}
    />
  );
};

export default Logo;
